export const authTranslations = {
  // Login page
  loginToZaviago: "Login to Zaviago",
  loginToFrappe: "Login to Frappe",
  loginDescriptionZaviago: "Enter your Zaviago credentials to access your workspace",
  loginDescriptionFrappe: "Enter your Frappe instance URL and credentials to access your ERPNext data",
  frappeInstanceUrl: "Frappe Instance URL",
  frappeUrlPlaceholder: "http://127.0.0.1:8000 or https://your-site.com",
  email: "Email",
  username: "Username",
  emailPlaceholder: "you@example.com",
  usernamePlaceholder: "administrator",
  password: "Password",
  passwordPlaceholder: "••••••••",
  loggingIn: "Logging in...",
  login: "Login",
  dontHaveAccount: "Don't have an account?",
  createOne: "Create one",

  // Error messages
  errorFrappeUrlRequired: "Please enter a Frappe instance URL",
  errorInvalidUrl: "Please enter a valid URL starting with http:// or https://",
  errorLoginFailed: "Login failed. Please check your credentials.",

  // Registration wizard
  back: "Back",
  next: "Next",
  skip: "Skip",
  alreadyHaveAccount: "Already have an account?",
  signIn: "Sign in",

  // Step: About You
  tellMeAboutYourself: "Tell me about yourself",
  letsStartWithYourName: "Let's start with your name",
  yourName: "Your name",
  namePlaceholder: "John",
  errorNameRequired: "Name is required",
  optional: "optional",

  // Intent-personalized About You headlines
  intentAboutYouHeadlineChat: "Let's set up your chat",
  intentAboutYouSublineChat: "We'll get your inbox ready — what's your name?",
  intentAboutYouHeadlineSelling: "Let's build your store",
  intentAboutYouSublineSelling: "We'll set up your storefront — what's your name?",
  intentAboutYouHeadlinePos: "Let's set up your POS",
  intentAboutYouSublinePos: "We'll configure your point of sale — what's your name?",
  intentAboutYouHeadlineCrm: "Let's organize your contacts",
  intentAboutYouSublineCrm: "We'll set up your CRM — what's your name?",
  firstName: "First name",
  firstNamePlaceholder: "John",
  lastName: "Last name",
  lastNamePlaceholder: "Doe",
  errorFirstNameRequired: "First name is required",
  errorLastNameRequired: "Last name is required",

  // Step: Contact
  howCanWeReachYou: "How can we reach you?",
  enterEmailAndPassword: "Enter your email and create a password",

  // Intent-personalized Contact headlines
  intentContactHeadlineChat: "Create your chat account",
  intentContactSublineChat: "Your email will be your login for the inbox",
  intentContactHeadlineSelling: "Create your store account",
  intentContactSublineSelling: "Your email will be your login for the dashboard",
  intentContactHeadlinePos: "Create your POS account",
  intentContactSublinePos: "Your email will be your login for the dashboard",
  intentContactHeadlineCrm: "Create your CRM account",
  intentContactSublineCrm: "Your email will be your login for the dashboard",
  minimumCharacters: "Minimum 8 characters",
  errorEmailRequired: "Email is required",
  errorEmailInvalid: "Please enter a valid email",
  errorPasswordRequired: "Password is required",
  errorPasswordMinLength: "Password must be at least 8 characters",

  // Step: Company
  whatsYourCompanyCalled: "What's your company called?",
  workspaceName: "This will be your workspace name",
  companyName: "Company name",
  companyNamePlaceholder: "Acme Inc",
  errorCompanyNameRequired: "Company name is required",
  errorCompanyNameMinLength: "Company name must be at least 2 characters",
  errorCompanyNameMaxLength: "Company name must be at most 50 characters",
  errorCompanyNameInvalidChars: "Company name cannot contain < > / \\ \" ` ; | { } [ ]",

  // Step: Phone
  whatsYourPhoneNumber: "What's your phone number?",
  phoneOptional: "Optional - for account recovery and notifications",
  phoneNumber: "Phone number",
  phoneNumberPlaceholder: "081 234 5678",

  // Step: Business Type
  whatTypeOfBusiness: "What type of business do you run?",
  businessTypeOptional: "Optional - helps us personalize your experience",
  searchBusinessTypes: "Search business types...",
  noResultsFound: "No results found",

  // Step: App Interests
  whichAppsToTry: "Which apps would you like to try?",
  appInterestsOptional: "Optional - select the features you're interested in",
  loadingApps: "Loading apps...",
  creatingWorkspace: "Creating your workspace...",
  startFreeTrial: "Start Free Trial",

  // General
  loading: "Loading...",
  registrationFailed: "Registration failed. Please try again.",

  // SMS OTP
  verifyYourPhone: 'Verify your phone number',
  otpDescription: "We'll send a verification code via SMS",
  sendOtpCode: 'Send verification code',
  sendingOtp: 'Sending...',
  enterVerificationCode: 'Enter verification code',
  otpSentTo: 'Code sent to',
  otpRefCode: 'Ref',
  verifyCode: 'Verify',
  verifyingCode: 'Verifying...',
  resendCode: 'Resend code',
  resendIn: 'Resend in',
  changeNumber: 'Change number',
  phoneVerified: 'Phone verified',
  errorPhoneRequired: 'Phone number is required',
  errorPhoneInvalid: 'Please enter a valid Thai mobile number',
  errorOtpExpired: 'Code has expired. Please request a new one.',
  errorOtpInvalid: 'Incorrect code. Please try again.',
  errorTooManyOtp: 'Too many attempts. Please wait 10 minutes.',

  // Login method selection (mobile-first)
  welcomeBack: "Welcome back",
  heroHeadline: "One app to run your entire business",
  heroSubline: "Manage sales, inventory, chat, rewards, and more — all in one place.",
  chooseSignInMethod: "Choose how you'd like to sign in",
  createAccount: "Create your account",
  chooseSignUpMethod: "Choose how you'd like to sign up",
  continueWithEmail: "Continue with Email",
  loginWithEmail: "Sign in with Email",
  enterYourCredentials: "Enter your email and password",

  // Google Login
  continueWithGoogle: "Continue with Google",
  googleLoginFailed: "Google sign-in failed",
  googleLoginProcessing: "Completing Google sign-in...",

  // LINE Login
  orContinueWith: "Or continue with",
  continueWithLine: "Continue with LINE",
  lineLoginFailed: "LINE login failed",
  lineLoginProcessing: "Completing LINE login...",
  lineCallbackInvalid: "Invalid callback. Please try logging in again.",
  lineStateInvalid: "Security validation failed. Please try logging in again.",
  backToLogin: "Back to Login",

  // === Intent-specific qualification steps (Phase 3) ===

  // Chat intent: channels
  chatChannelsTitle: "Connect your channels",
  chatChannelsSubtitle: "Select all that apply",
  chatChannelLineOA: "LINE Official Account",
  chatChannelFacebook: "Facebook Messenger",
  chatChannelInstagram: "Instagram DM",
  chatChannelWebsite: "Website live chat",
  chatChannelWhatsApp: "WhatsApp",
  chatChannelTelegram: "Telegram",
  chatChannelEmail: "Email",
  chatChannelTwitter: "X (Twitter)",
  chatChannelOther: "Other channels",

  // Chat intent: volume
  chatVolumeTitle: "How many messages per day?",
  chatVolumeSubtitle: "Approximate daily incoming messages",
  chatVolumeUnder50: "Under 50",
  chatVolume50to200: "50 – 200",
  chatVolume200to500: "200 – 500",
  chatVolumeOver500: "500+",

  // Selling intent: category
  sellingCategoryTitle: "What type of products do you sell?",
  sellingCategorySubtitle: "Helps us set up your storefront",
  sellingCatFashion: "Fashion & Apparel",
  sellingCatFood: "Food & Beverage",
  sellingCatBeauty: "Beauty & Cosmetics",
  sellingCatElectronics: "Electronics & Gadgets",
  sellingCatHome: "Home & Living",
  sellingCatOther: "Other",

  // Selling intent: channels
  sellingChannelsTitle: "Where do you sell?",
  sellingChannelsSubtitle: "Select all channels you sell on",
  sellingChOwnWebsite: "Own website",
  sellingChShopee: "Shopee",
  sellingChLazada: "Lazada",
  sellingChTikTok: "TikTok Shop",
  sellingChLine: "LINE",
  sellingChFacebook: "Facebook",
  sellingChInstagram: "Instagram",
  sellingChOffline: "Physical store",

  // POS intent: store type
  posTypeTitle: "What kind of store do you have?",
  posTypeSubtitle: "Helps us configure your POS",
  posTypeCafe: "Cafe / Coffee shop",
  posTypeRestaurant: "Restaurant",
  posTypeRetail: "Retail store",
  posTypeService: "Service (salon, spa, etc.)",
  posTypeOther: "Other",

  // POS intent: branches
  posBranchesTitle: "How many branches?",
  posBranchesSubtitle: "Including your main location",
  posBranches1: "1 location",
  posBranches2to5: "2 – 5 branches",
  posBranches6to20: "6 – 20 branches",
  posBranchesOver20: "20+ branches",

  // CRM intent: team size
  crmTeamSizeTitle: "How big is your sales team?",
  crmTeamSizeSubtitle: "People who manage customer relationships",
  crmTeamSolo: "Just me",
  crmTeam2to5: "2 – 5 people",
  crmTeam6to20: "6 – 20 people",
  crmTeamOver20: "20+ people",

  // CRM intent: current tool
  crmCurrentToolTitle: "What do you use to manage customers?",
  crmCurrentToolSubtitle: "Your current tool — we'll help you switch",
  crmToolExcel: "Excel / Google Sheets",
  crmToolLineNotes: "LINE chat / notes app",
  crmToolCrmApp: "Another CRM app",
  crmToolNothing: "Nothing yet",

  // === Desktop Handoff (Phase 4) ===
  desktopHandoffTitle: "Want to continue on desktop?",
  desktopHandoffSubtitle: "Enter your email and we'll send you a magic login link — open it on your computer to get started right away.",
  desktopHandoffEmailPlaceholder: "your@email.com",
  desktopHandoffSendLink: "Send me the link",
  desktopHandoffSkip: "Skip — I'll stay on mobile",
  desktopHandoffEmailRequired: "Please enter your email",
  desktopHandoffEmailInvalid: "Please enter a valid email",
  desktopHandoffLineEmailNudge: "Please use a personal or work email — not your LINE email",
} as const;
